export const employmentTypeToText = (type: string) => {
	switch (type) {
		case "FULL_TIME":
			return "Full Time";
		case "PART_TIME":
			return "Part Time";
		case "CONTRACT":
			return "Contract";
		default:
			return "Unknown";
	}
};
